import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { RechargeSeuStep2 } from 'pages/recharge-seu-step-2';
import { DepositMode } from 'services/recharges/recharges.config';
import { z } from 'zod';

const recharegeStep2SearchSchema = z.object({
  formIdFromUrl: z.string().optional(),
  amount: z.number().optional(),
  promoCode: z.string().optional(),
  method: z.enum(DepositMode),
  selectBonus: z.string().optional(),
  showPdvDepositModal: z.boolean().optional(),
});

export const Route = createFileRoute('/_auth/topup/step2')({
  component: RechargeSeuStep2,
  validateSearch: zodValidator(recharegeStep2SearchSchema),
});
